(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-besoin-acne"]) return;
  try {
    
(function() {
  // SLIDER
  document.querySelectorAll('.mc-ac-slider-wrapper').forEach(function(wrapper) {
    var range = wrapper.querySelector('.mc-ac-slider-range');
    var afterImg = wrapper.querySelector('.mc-ac-slider-after');
    var handle = wrapper.querySelector('.mc-ac-slider-handle');
    function update(val) {
      var pct = 100 - parseInt(val);
      afterImg.style.clipPath = 'inset(0 ' + pct + '% 0 0)';
      handle.style.left = val + '%';
    }
    range.addEventListener('input', function() { update(this.value); });
    update(50);
  });

  // QUIZ
  var optionsEl = document.getElementById('mc-ac-quiz-options');
  if (!optionsEl) return;

  optionsEl.querySelectorAll('.mc-ac-quiz-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      var resultEl = document.getElementById('mc-ac-result-' + opt.dataset.acResult);
      optionsEl.style.display = 'none';
      document.querySelector('.mc-ac-quiz-question').style.display = 'none';
      document.querySelector('.mc-ac-quiz-subtitle').style.display = 'none';
      if (resultEl) {
        resultEl.classList.add('mc-ac-visible');
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('#mc-quiz-ac .mc-ac-quiz-reset').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.mc-ac-quiz-results').forEach(function(r) { r.classList.remove('mc-ac-visible'); });
      optionsEl.style.display = 'grid';
      document.querySelector('.mc-ac-quiz-question').style.display = 'block';
      document.querySelector('.mc-ac-quiz-subtitle').style.display = 'block';
      optionsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-besoin-anti-taches"]) return;
  try {
    
(function() {
  // SLIDER
  document.querySelectorAll('.mc-slider-wrapper').forEach(function(wrapper) {
    var range = wrapper.querySelector('.mc-slider-range');
    var afterImg = wrapper.querySelector('.mc-slider-after');
    var handle = wrapper.querySelector('.mc-slider-handle');
    function update(val) {
      var pct = 100 - parseInt(val);
      afterImg.style.clipPath = 'inset(0 ' + pct + '% 0 0)';
      handle.style.left = val + '%';
    }
    range.addEventListener('input', function() { update(this.value); });
    update(50);
  });

  // QUIZ
  var optionsEl = document.getElementById('mc-quiz-options-at');
  if (!optionsEl) return;

  optionsEl.querySelectorAll('.mc-quiz-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      var resultEl = document.getElementById('mc-result-' + opt.dataset.result);
      optionsEl.style.display = 'none';
      document.querySelector('.mc-quiz-question').style.display = 'none';
      document.querySelector('.mc-quiz-subtitle').style.display = 'none';
      if (resultEl) {
        resultEl.classList.add('mc-visible');
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('#mc-quiz-at .mc-quiz-reset').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.mc-quiz-results').forEach(function(r) { r.classList.remove('mc-visible'); });
      optionsEl.style.display = 'grid';
      document.querySelector('.mc-quiz-question').style.display = 'block';
      document.querySelector('.mc-quiz-subtitle').style.display = 'block';
      optionsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-besoin-antiage"]) return;
  try {
    
(function() {
  // SLIDER
  document.querySelectorAll('.mc-aa-slider-wrapper').forEach(function(wrapper) {
    var range = wrapper.querySelector('.mc-aa-slider-range');
    var afterImg = wrapper.querySelector('.mc-aa-slider-after');
    var handle = wrapper.querySelector('.mc-aa-slider-handle');
    function update(val) {
      var pct = 100 - parseInt(val);
      afterImg.style.clipPath = 'inset(0 ' + pct + '% 0 0)';
      handle.style.left = val + '%';
    }
    range.addEventListener('input', function() { update(this.value); });
    update(50);
  });

  // QUIZ
  var optionsEl = document.getElementById('mc-aa-quiz-options');
  if (!optionsEl) return;

  optionsEl.querySelectorAll('.mc-aa-quiz-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      var resultEl = document.getElementById('mc-aa-result-' + opt.dataset.aaResult);
      optionsEl.style.display = 'none';
      document.querySelector('.mc-aa-quiz-question').style.display = 'none';
      document.querySelector('.mc-aa-quiz-subtitle').style.display = 'none';
      if (resultEl) {
        resultEl.classList.add('mc-aa-visible');
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('#mc-quiz-aa .mc-aa-quiz-reset').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.mc-aa-quiz-results').forEach(function(r) { r.classList.remove('mc-aa-visible'); });
      optionsEl.style.display = 'grid';
      document.querySelector('.mc-aa-quiz-question').style.display = 'block';
      document.querySelector('.mc-aa-quiz-subtitle').style.display = 'block';
      optionsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-besoin-eclat"]) return;
  try {
    
(function() {
  // SLIDER
  document.querySelectorAll('.mc-ec-slider-wrapper').forEach(function(wrapper) {
    var range = wrapper.querySelector('.mc-ec-slider-range');
    var afterImg = wrapper.querySelector('.mc-ec-slider-after');
    var handle = wrapper.querySelector('.mc-ec-slider-handle');
    function update(val) {
      var pct = 100 - parseInt(val);
      afterImg.style.clipPath = 'inset(0 ' + pct + '% 0 0)';
      handle.style.left = val + '%';
    }
    range.addEventListener('input', function() { update(this.value); });
    update(50);
  });

  // QUIZ
  var optionsEl = document.getElementById('mc-ec-quiz-options');
  if (!optionsEl) return;

  optionsEl.querySelectorAll('.mc-ec-quiz-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      var resultEl = document.getElementById('mc-ec-result-' + opt.dataset.ecResult);
      optionsEl.style.display = 'none';
      document.querySelector('.mc-ec-quiz-question').style.display = 'none';
      document.querySelector('.mc-ec-quiz-subtitle').style.display = 'none';
      if (resultEl) {
        resultEl.classList.add('mc-ec-visible');
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('#mc-quiz-ec .mc-ec-quiz-reset').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.mc-ec-quiz-results').forEach(function(r) { r.classList.remove('mc-ec-visible'); });
      optionsEl.style.display = 'grid';
      document.querySelector('.mc-ec-quiz-question').style.display = 'block';
      document.querySelector('.mc-ec-quiz-subtitle').style.display = 'block';
      optionsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-besoin-zones-sombres"]) return;
  try {
    
(function() {
  // SLIDER
  document.querySelectorAll('.mc-zs-slider-wrapper').forEach(function(wrapper) {
    var range = wrapper.querySelector('.mc-zs-slider-range');
    var afterImg = wrapper.querySelector('.mc-zs-slider-after');
    var handle = wrapper.querySelector('.mc-zs-slider-handle');
    function update(val) {
      var pct = 100 - parseInt(val);
      afterImg.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = val + '%';
    }
    range.addEventListener('input', function() { update(this.value); });
    update(50);
  });

  // QUIZ
  var optionsEl = document.getElementById('mc-zs-quiz-options');
  if (!optionsEl) return;

  optionsEl.querySelectorAll('.mc-zs-quiz-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      var resultEl = document.getElementById('mc-zs-result-' + opt.dataset.zsResult);
      optionsEl.style.display = 'none';
      document.querySelector('.mc-zs-quiz-question').style.display = 'none';
      document.querySelector('.mc-zs-quiz-subtitle').style.display = 'none';
      if (resultEl) {
        resultEl.classList.add('mc-zs-visible');
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('#mc-quiz-zs .mc-zs-quiz-reset').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.mc-zs-quiz-results').forEach(function(r) { r.classList.remove('mc-zs-visible'); });
      optionsEl.style.display = 'grid';
      document.querySelector('.mc-zs-quiz-question').style.display = 'block';
      document.querySelector('.mc-zs-quiz-subtitle').style.display = 'block';
      optionsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
